import React, { useCallback, useMemo, useRef, useState, useEffect } from "react";
import Editor from "@draft-js-plugins/editor";
import createMentionPlugin, { defaultSuggestionsFilter } from "@draft-js-plugins/mention";
import styled from "styled-components";
import userIcon from "../assets/images/user_icone.png";

export const EditorStyle = styled.div`
    box-sizing: border-box;
    border: 1px solid #ddd;
    cursor: text;
    padding: 16px;
    border-radius: 2px;
    box-shadow: inset 0px 1px 8px -3px #ababab;
    background: #fefefe;
    width: 100%;

    .DraftEditor-root :global(.public-DraftEditor-content) {
        min-height: 140px;
    }
`;
export default function TextInputWithMentioned({ editorState, handleOnChange, mentionedOptions }) {
    const ref = useRef(null);
    const [open, setOpen] = useState(false);
    const [suggestions, setSuggestions] = useState();
    let convertedAdmins = [];
    const [users, setUsers] = useState([]);
    const [userMention, setUserMention] = useState([]);

    const { MentionSuggestions, plugins } = useMemo(() => {
        const mentionPlugin = createMentionPlugin();
        // eslint-disable-next-line no-shadow
        const { MentionSuggestions } = mentionPlugin;
        // eslint-disable-next-line no-shadow
        const plugins = [mentionPlugin];
        return { plugins, MentionSuggestions };
    }, []);

    useEffect(() => {
        // let response
        if (mentionedOptions?.length > 0) {
            initAdmins();
            setSuggestions(convertedAdmins);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mentionedOptions]);

    const onSearchChange = useCallback(
        ({ trigger, value }) => {
            setSuggestions(defaultSuggestionsFilter(value, users, trigger));
        },
        [users]
    );
    const initAdmins = async () => {
        if (mentionedOptions?.length > 0) {
            const userAdmins = mentionedOptions?.map((convertedAdmin) => ({
                name: convertedAdmin.attributes.email,
                id: convertedAdmin.id,
                link: convertedAdmin.links.self,
                avatar: userIcon,
            }));
            convertedAdmins = userAdmins;
            setUsers(userAdmins);
        }
    };

    const onOpenChange = useCallback((_open) => {
        setOpen(_open);
    }, []);

    const onAddMentions = useCallback(
        (mentionSelected) => {
            const mentions = [...userMention, mentionSelected];
            setUserMention(mentions);
        },
        [userMention]
    );

    return (
        <EditorStyle>
            <div
                onClick={() => {
                    ref.current.focus();
                }}
            >
                <Editor
                    editorKey="editor"
                    editorState={editorState}
                    onChange={handleOnChange}
                    plugins={plugins}
                    ref={ref}
                />
                <MentionSuggestions
                    open={open}
                    onOpenChange={onOpenChange}
                    suggestions={suggestions}
                    onSearchChange={onSearchChange}
                    onAddMention={onAddMentions}
                />
            </div>
        </EditorStyle>
    );
}
